import { render, staticRenderFns } from "./BikyConfigChatCorrectResponse.vue?vue&type=template&id=52b496ca&scoped=true&"
import script from "./BikyConfigChatCorrectResponse.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigChatCorrectResponse.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigChatCorrectResponse.vue?vue&type=style&index=0&id=52b496ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b496ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
